import { render, staticRenderFns } from "./PixelFb.vue?vue&type=template&id=f97f3adc&scoped=true&"
import script from "./PixelFb.vue?vue&type=script&lang=js&"
export * from "./PixelFb.vue?vue&type=script&lang=js&"
import style0 from "./PixelFb.vue?vue&type=style&index=0&id=f97f3adc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97f3adc",
  null
  
)

export default component.exports